import { createGlobalStyle } from 'styled-components'
import { theme } from '@/styles/theme'

export const GlobalStyle = createGlobalStyle`
  :root {
    font-size: 16px;
    overflow-y: scroll;
  }

  #root {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  #modal-root {
    position: relative;
    z-index: 999;
  }

  html {
    background-color: ${theme.colors.accentGreen};
  }

  body, div {
    box-sizing: border-box;
    font-family: ${theme.fonts.roboto};
  }

  body {
    color: ${theme.colors.accentGreen};
    background-color: ${theme.colors.background};
    font-family: Roboto;
    margin: 0;
  }
  h2,
  h3,
  h4,h5,h6{
    margin: 0;
    
  }
  p,h4,h5,
  th {
    color:  ${theme.palette.bushlandDeep};
    
  }
  * {
  box-sizing: border-box;

  }
  a {
    color: inherit;
    outline: none;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }


`
